"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpersonateDropdown = exports.ImpersonateBorderStyle = exports.ImpersonateDropdownMenu = exports.ImpersonateButton = void 0;
require("isomorphic-fetch");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var globalCss_1 = require("../../globalCss");
var globalVars_module_scss_1 = __importDefault(require("../../globalVars.module.scss"));
var Common_1 = require("../Common");
var Dropdown_1 = require("../Dropdown");
var UserSessionStore_1 = require("../Session/UserSessionStore");
exports.ImpersonateButton = styled_components_1.default.button.attrs({
    className: 'tws-impersonateMenu',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n\tdisplay: inline-flex;\n\tposition: fixed;\n\tleft: 50%;\n\tmargin: 0 0 0 -125px;\n\theight: 30px !important;\n\twidth: 230px;\n\tborder: 0;\n\tborder-radius: 0 0 3px 3px;\n\tbackground-color: #3fa9f5;\n\tcolor: white !important;\n\talign-items: center;\n\tjustify-content: center;\n\tbox-shadow: none;\n\tz-index: 2;\n\tcursor: pointer;\n\tpadding: 0 10px;\n\ttop: 0;\n\tz-index: 1021;\n\tposition: fixed;\n"], ["\n\t", "\n\tdisplay: inline-flex;\n\tposition: fixed;\n\tleft: 50%;\n\tmargin: 0 0 0 -125px;\n\theight: 30px !important;\n\twidth: 230px;\n\tborder: 0;\n\tborder-radius: 0 0 3px 3px;\n\tbackground-color: #3fa9f5;\n\tcolor: white !important;\n\talign-items: center;\n\tjustify-content: center;\n\tbox-shadow: none;\n\tz-index: 2;\n\tcursor: pointer;\n\tpadding: 0 10px;\n\ttop: 0;\n\tz-index: 1021;\n\tposition: fixed;\n"])), globalCss_1.bodyCopyMedium);
exports.ImpersonateButton.displayName = 'ImpersonateMenu';
var ImpersonateIcon = (0, styled_components_1.default)(Common_1.Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tfont-size: 25px;\n\tmargin-right: 10px;\n"], ["\n\tfont-size: 25px;\n\tmargin-right: 10px;\n"])));
var CaretIcon = (0, styled_components_1.default)(Common_1.Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tfont-size: 9px;\n\tmargin-left: 20px;\n"], ["\n\tfont-size: 9px;\n\tmargin-left: 20px;\n"])));
exports.ImpersonateDropdownMenu = (0, styled_components_1.default)(Dropdown_1.DropdownMenu)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 230px !important;\n\tposition: fixed;\n\tz-index: 1021;\n"], ["\n\twidth: 230px !important;\n\tposition: fixed;\n\tz-index: 1021;\n"])));
var UserName = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tfont-weight: ", ";\n"], ["\n\tfont-weight: ", ";\n"])), globalVars_module_scss_1.default.fontWeightBold);
exports.ImpersonateBorderStyle = {
    position: 'fixed',
    zIndex: 1021,
    backgroundColor: "".concat(globalVars_module_scss_1.default.tertiaryBlue1),
};
var ImpersonateBorderStyleTop = __assign(__assign({}, exports.ImpersonateBorderStyle), { paddingTop: '4px', top: '0px', width: '100%' });
var ImpersonateBorderStyleRight = __assign(__assign({}, exports.ImpersonateBorderStyle), { paddingRight: '4px', right: '0px', height: '100%' });
var ImpersonateBorderStyleBottom = __assign(__assign({}, exports.ImpersonateBorderStyle), { paddingBottom: '4px', bottom: '0px', width: '100%' });
var ImpersonateBorderStyleLeft = __assign(__assign({}, exports.ImpersonateBorderStyle), { paddingLeft: '4px', left: '0px', height: '100%' });
var ImpersonateDropdown = /** @class */ (function (_super) {
    __extends(ImpersonateDropdown, _super);
    function ImpersonateDropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            open: false,
            x: 0,
            y: 0,
        };
        _this.showDropdown = _this.showDropdown.bind(_this);
        _this.hideDropdown = _this.hideDropdown.bind(_this);
        _this.endImpersonation = _this.endImpersonation.bind(_this);
        _this.logout = _this.logout.bind(_this);
        return _this;
    }
    ImpersonateDropdown.prototype.render = function () {
        return (React.createElement("div", null, this.props.impersonatorName && (React.createElement("div", null,
            React.createElement(exports.ImpersonateButton, { onClick: this.showDropdown },
                React.createElement(ImpersonateIcon, { name: 'impersonate' }),
                "Impersonation Mode",
                !this.state.open && React.createElement(CaretIcon, { name: 'caret-down' }),
                this.state.open && React.createElement(CaretIcon, { name: 'caret-up' })),
            React.createElement(exports.ImpersonateDropdownMenu, { onBlur: this.hideDropdown, open: this.state.open, x: this.state.x, y: this.state.y },
                React.createElement(Dropdown_1.DropdownMenuItem, { onClick: this.endImpersonation }, "End Impersonation"),
                React.createElement(Dropdown_1.DropdownMenuItem, { onClick: this.logout },
                    "Logout,\u00A0",
                    React.createElement(UserName, null, this.props.impersonatorName))),
            React.createElement("div", { style: ImpersonateBorderStyleLeft }),
            React.createElement("div", { style: ImpersonateBorderStyleRight }),
            React.createElement("div", { style: ImpersonateBorderStyleTop }),
            React.createElement("div", { style: ImpersonateBorderStyleBottom })))));
    };
    ImpersonateDropdown.prototype.endImpersonation = function () {
        return UserSessionStore_1.UserSessionStore.endImpersonation(this.props.identityServerUrl);
    };
    ImpersonateDropdown.prototype.logout = function () {
        if (this.props.userManager) {
            return UserSessionStore_1.UserSessionStore.logout(this.props.userManager);
        }
    };
    ImpersonateDropdown.prototype.showDropdown = function () {
        // set the button's bounding box so we know the x,y to align the dropdown
        var parent = document.getElementsByClassName('tws-impersonateMenu');
        var bounds = parent && parent.item(0) && parent.item(0).getBoundingClientRect();
        var newOpenState = !this.state.open;
        if (bounds) {
            this.setState({ open: newOpenState, x: bounds.left, y: bounds.bottom });
        }
        else {
            this.setState(function (prevState) { return (__assign(__assign({}, prevState), { open: newOpenState })); });
        }
    };
    ImpersonateDropdown.prototype.hideDropdown = function () {
        var _this = this;
        setTimeout(function () {
            _this.setState({ open: false });
        }, 200);
    };
    return ImpersonateDropdown;
}(React.Component));
exports.ImpersonateDropdown = ImpersonateDropdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
